export const VENDOR_LIST = "SLOT_VENDOR_LIST";
export const GAME_LIST = "SLOT_GAME_LIST";
export const SLOT_GAME_ACCESS = "SLOT_GAME_ACCESS";